import { Spin } from "antd";

export const Loader = () => {
  return (
      <Spin size="large">Загрузка</Spin>
  );
};
